import { Type } from "@sinclair/typebox";
import { MAX_PERSISTED_INTEGER } from "../units.js";
export const MillimetresSchema = Type.Unsafe(Type.Integer({
    minimum: 0,
    maximum: MAX_PERSISTED_INTEGER,
}));
export const PositiveMillimetresSchema = Type.Unsafe(Type.Integer({
    minimum: 1,
    maximum: MAX_PERSISTED_INTEGER,
}));
export const MilligramsSchema = Type.Unsafe(Type.Integer({
    minimum: 0,
    maximum: MAX_PERSISTED_INTEGER,
}));
export const PositiveMilligramsSchema = Type.Unsafe(Type.Integer({
    minimum: 1,
    maximum: MAX_PERSISTED_INTEGER,
}));
export const SquareMillimetresSchema = Type.Unsafe(Type.Integer({
    minimum: 1,
    maximum: MAX_PERSISTED_INTEGER,
}));
export const CubicMillimetresSchema = Type.Unsafe(Type.Integer({
    minimum: 0,
    maximum: MAX_PERSISTED_INTEGER,
}));
export const ErrorResponseSchema = Type.Object({
    error: Type.Object({
        code: Type.Union([
            Type.Literal("VALIDATION_ERROR"),
            Type.Literal("PERSISTED_INTEGER_INVALID"),
            Type.Literal("CSV_INVALID"),
            Type.Literal("UNAUTHENTICATED"),
            Type.Literal("FORBIDDEN"),
            Type.Literal("AUTH_RESTRICTED"),
            Type.Literal("CONFLICT"),
            Type.Literal("RATE_LIMITED"),
            Type.Literal("NOT_FOUND"),
            Type.Literal("DEPENDENCY_UNAVAILABLE"),
            Type.Literal("INTERNAL_ERROR"),
        ]),
        message: Type.String({ minLength: 1 }),
        details: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
    }, { additionalProperties: false }),
}, { additionalProperties: false });
//# sourceMappingURL=common.js.map